import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

const NotificationPlaceholder: React.FC<IContentLoaderProps> = (props) => {
  return (
    <ContentLoader
      {...props}
      viewBox="0 0 840 130"
      backgroundColor="#e7f1fc"
      foregroundColor="#ffffff"
    >
      <circle cx="48" cy="65" r="24" />
      <rect x="88" y="32" rx="8" ry="8" width="680" height="16" />
      <rect x="88" y="56" rx="8" ry="8" width="400" height="16" />
      <rect x="88" y="100" rx="8" ry="8" width="120" height="14" />
      <rect x="650" y="100" rx="8" ry="8" width="120" height="14" />
    </ContentLoader>
  );
};

export default NotificationPlaceholder;
